import { IconActionSearch24 } from '@cian/ui-kit';
import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectGeo } from '../../../selectors/geo';
import { selectPageType } from '../../../selectors/page';
import { IMobileNavigationItem } from '../../../types/mobileBottomNavigation';
import { useApplicationContext } from '../../../utils/applicationContext';
import { trackNavigationItemClick } from '../tracking';

export const useSearchNavigationItem = (): IMobileNavigationItem => {
  const {
    custom: { subdomain },
  } = useApplicationContext();
  const { regionId, cityId } = useSelector(selectGeo);
  const region = cityId || /* istanbul ignore next */ regionId;

  const [lastSearchLink, setLastSearchLink] = useState(
    `https://${subdomain}.cian.ru/nd/search/?deal_type=sale&engine_version=2&offer_type=flat&region=${region}`,
  );

  useEffect(() => {
    const searchLink = Cookies.get('lastSearchLink');

    /* istanbul ignore next */
    if (searchLink) {
      setLastSearchLink(decodeURIComponent(searchLink));
    }
  }, []);

  const page = useSelector(selectPageType);

  const handleClick = useCallback(() => {
    trackNavigationItemClick('search');
  }, []);

  return {
    title: 'Поиск',
    link: lastSearchLink,
    icon: IconActionSearch24,
    isActive: page === 'search',
    onClick: handleClick,
  };
};
